import type { AxiosResponse } from 'axios';

export interface BeListEnvelope<T> {
  data: T[];
  pagination: {
    total?: number;
    page?: number;
    page_size?: number;
    limit?: number;       // some legacy endpoints still return this
    skip?: number;
    total_pages?: number;
  };
  success: true;
}

export interface BeObjectEnvelope<T> {
  data: T;
  success: true;
}

export interface ListResult<T> {
  data: T[];
  total: number;
}

export function unwrapList<T>(res: AxiosResponse<BeListEnvelope<T>>): ListResult<T> {
  return {
    data: res.data.data,
    total: res.data.pagination?.total ?? res.data.data.length,
  };
}

export function unwrapObject<T>(res: AxiosResponse<BeObjectEnvelope<T>>): T {
  return res.data.data;
}

export class BeGapError extends Error {
  constructor(endpoint: string) {
    super(`BE endpoint not implemented yet: ${endpoint}`);
    this.name = 'BeGapError';
  }
}
